import {
    classNames,
    EmailKeyboardLayout,
    Keyboard,
    layout,
    PushButton,
    TextInput,
    theme,
    useTypeRef,
    View
} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useEffect, useRef, useState} from "react";
import {stylesheet} from "typestyle";
import {useLocalization} from "../i18n";

interface EmailViewProps {
    onEmail: (email: string) => any;
    onSkip: () => any;
}

export function EmailView({onEmail, onSkip}: EmailViewProps) {
    const {t} = useLocalization();
    const [email, setEmail] = useState("");
    const input = useRef<HTMLInputElement|null>();
    const [type, setType] = useTypeRef();

    useEffect(() => {
        if (input.current) {
            input.current.focus();
        }
    }, [input.current]);

    const handleSubmit = useCallback(() => onEmail(email), [onEmail, email]);

    return (
        <View className={classNames(layout.vertical, layout.spaceEvenly)}>
            <div className={classNames(layout.paddingMedium)}>
                <div className={styles.title}>
                    {t("EnterEmail")}
                </div>
                <div>
                    {t("EnterEmailDescription")}
                </div>
            </div>

            <div className={classNames(theme.moreContrast)}>
                <TextInput
                    onChange={setEmail}
                    value={email}
                    placeholder={t("EmailAddressPlaceholder")}
                    inputRef={input}
                    typeRef={setType}
                    className={classNames(layout.fill, styles.textInput)}
                />
                <Keyboard
                    className={classNames(styles.keyboard)}
                    onType={type}
                    border={false}
                    layout={EmailKeyboardLayout}
                />
            </div>

            <div className={classNames(layout.paddingMedium)}>
                <div className={classNames(layout.horizontal, layout.spaceBetween)}>
                    <div>
                        <PushButton onClick={onSkip}>{t("Skip")}</PushButton>
                    </div>
                    <div>
                        <PushButton primary onClick={handleSubmit}>
                            {t("Next")}
                        </PushButton>
                    </div>
                </div>
            </div>

        </View>
    );
}

const styles = stylesheet({
    title: {
        fontSize: "1.75rem",
    },
    textInput: {
        fontWeight: "bold",
        width: "100%",
        height: "4rem",
        fontSize: "2em",
    },
    keyboard: {
        backgroundColor: "transparent",
        fontSize: "1.25rem",
    },
})